var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.72,
    height: 19.04,
    viewBox: "0 0 20.72 19.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONOS_FLUJO",
    "data-name": "ICONOS FLUJO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_14",
    "data-name": "Capa 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81,22c-5,0-5-2.74-5-5.16V16c0-2,0-4.26,4.11-4.26a2.64,2.64,0,0,1,2,.67.65.65,0,0,1,.09.08l.88,1a2,2,0,0,0,2.84,0l.88-1,.09-.08a2.62,2.62,0,0,1,1.95-.67c4.11,0,4.11,2.26,4.11,4.26v.9c0,3.43-1.69,5.16-5,5.16ZM4.13,16v.9c0,2.46,0,3.81,3.68,3.81h6.93c2.57,0,3.67-1.14,3.67-3.81V16c0-2,0-2.92-2.81-2.92a1.37,1.37,0,0,0-1.12.37l-.84.92a3.17,3.17,0,0,1-4.73,0l-.84-.92A1.38,1.38,0,0,0,6.94,13C4.13,13,4.13,14,4.13,16Z",
    transform: "translate(-1.19 -2.96)",
    fill: "{props.color}",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.2,15.23",
    transform: "translate(-1.19 -2.96)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa_19",
    "data-name": "Capa 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.46,8.9l.84.51.21.13a.45.45,0,0,1-.47.77l-1.42-.86a.46.46,0,0,1-.1-.67L13.63,7a.4.4,0,0,1,.6-.16.44.44,0,0,1,.14.61l-.75,1.22Z",
    transform: "translate(-1.19 -2.96)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.42,5.89c.23.14.34.2.49.31a4.29,4.29,0,0,1,1.5,2c.44,1.38-.28,2.78-.84,3.87a9.62,9.62,0,0,1-.88,1.38,6.11,6.11,0,0,1-.6.53c-.3.24-.7.55-.78.48s0-.34.72-1.42l.67-1.11C15.25,9.35,15.05,8,13,6.77L10.26,5.1c-2-1.25-3.32-.81-4.87,1.74l-2.13,3.5a7.21,7.21,0,0,0-.55,1.19,3.5,3.5,0,0,0-.28,2.06,2.79,2.79,0,0,0,1.39,1.62v.4c0,.14,0,.29,0,.44s0,.3,0,.44l-.31-.26C1.08,14.76.8,12.85,2.65,9.8l2-3.32c1.82-3,3.64-3.62,6.07-2.15C10.89,4.42,11.74,4.9,13.42,5.89Z",
    transform: "translate(-1.19 -2.96)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "lineas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36,10,6.29,8.87s-.11,0-.11-.08a.86.86,0,0,1,.08-.41.83.83,0,0,1,.3-.26c.05,0,.08,0,.12.05l4.16,2.33s.08,0,.1.06.07.2,0,.41-.24.3-.34.28l-.1-.05Z",
    transform: "translate(-1.19 -2.96)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83,8.12l-1.3-.73c-.16-.09-.18-.28,0-.5s.3-.27.42-.19l2.61,1.46c.16.09.18.26,0,.49s-.3.27-.42.2Z",
    transform: "translate(-1.19 -2.96)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17.92,
    cy: 2.8,
    r: 2.3,
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(16.22 4.26) scale(1.47 1)",
    fontSize: 4,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, "1"))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.46,22",
    transform: "translate(-1.19 -2.96)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88,17.54",
    transform: "translate(-1.19 -2.96)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.31b6f2107ddbce3544f5c0bcf57e9161.svg";
export { ForwardRef as ReactComponent };